import React, { ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { ResponsiveHeightType, ResponsiveWidthType } from '@fiverr-private/theme/src/components/Box/types';
import { HeadingElement } from '@fiverr-private/typography/src/components/Typography/types';

interface EmptyStateProps {
  image?: ReactNode;
  title: string;
  description: string;
  leftButton?: ReactNode;
  rightButton?: ReactNode;
  minHeight?: ResponsiveHeightType;
  titleElement?: HeadingElement;
  titleMaxWidth?: ResponsiveWidthType;
  descSize?: 'b_sm' | 'b_md';
  descMaxWidth?: ResponsiveWidthType;
}

export const EmptyState = ({
  image,
  title,
  description,
  leftButton,
  rightButton,
  minHeight = '60vh',
  titleElement = 'h6',
  titleMaxWidth = '550px',
  descSize = 'b_sm',
  descMaxWidth = '450px',
}: EmptyStateProps) => (
  <Stack gap="8" direction="column" alignItems="center" justifyContent="center" minHeight={minHeight}>
    <Stack gap="10" direction="column" alignItems="center" wrap="wrap">
      {image}
      <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
        <Heading textAlign="center" as={titleElement} maxWidth={titleMaxWidth}>
          {title}
        </Heading>
        <Text textAlign="center" size={descSize} maxWidth={descMaxWidth}>
          {description}
        </Text>
      </Stack>
    </Stack>
    <Stack direction="row" gap="4" justifyContent="center" alignItems="center" wrap="wrap">
      {leftButton}
      {rightButton}
    </Stack>
  </Stack>
);
